module.exports = __webpack_public_path__ + "static/img/zkj-auc-suc-icon.a64d3a4a.png";